<template>
    <div>
        <b-form-checkbox-group>
            <div class="custom-control custom-checkbox" v-for="item in constraints.selectables.items" v-bind:key="item">
                <input 
                    type="checkbox" 
                    class="custom-control-input" 
                    :id="field.key + '_' + item" 
                    :value="item"
                    :name="field.key"
                    v-model="content" 
                    />
                <label class="custom-control-label" :for="field.key + '_' + item"> {{ item }} </label>
            </div>
        </b-form-checkbox-group>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
export default {
    name: "IdentityFieldCheckbox_Number",
    props: {
        field: {
            type: Object
        },
        value: {
            type: Array | String
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "") {
                    return []
                }
                
                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    methods: {
        check(val) {
            val = val || 0
            this.errors = []

            if (this.constraints.required) {
                if (val.length < 1) {
                    this.errors.push(this.translator("identityField.requiredField"))
                }
            }

            if (val < this.constraints.selectables.range.from || val > this.constraints.selectables.range.from) {
                this.errors.push(this.translator("identityField.numberNotInRange"))
            }

            if (this.constraints.selectables.items.indexOf(val) == -1) {
                this.errors.push(this.translator("identityField.invalidNumber"))
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },

    created() {
        let selectable = this.constraints.selectables
        
        if (selectable.range.from != null && selectable.range.to != null) {
            for (let i = selectable.range.from; i <= selectable.range.to; i++) {
                if (selectable.items.indexOf(i) == -1) {
                    selectable.items.push(i)
                }
            }
        }
    },

    mounted() {
        this.check(this.content)
    }
}
</script>